import React, { useEffect, useMemo, useState } from "react";
import RowSelectingTable from "./RowSelectingTable";
import { useTranslation } from "react-i18next";
import getClientData from "../../inputData/clientData";
import { useSelector } from "react-redux";

const ClientsList = (props) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);

  const [activeUser, setActiveUser] = useState({});

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  const { clientColumns } = useMemo(
    () =>
      getClientData({
        t,
        isAdminOrTenant:
          activeUser.role === "admin" || activeUser.role === "tenant",
      }),
    [t, activeUser]
  );
  if (props.clientList) {
    return (
      <RowSelectingTable
        columns={clientColumns}
        data={props.clientList}
        shownClient={props.shownClient}
        setShownClient={props.setShownClient}
        setOpen={props.setOpen}
        setSingleIsShown={props.setSingleIsShown}
        title={props.title}
        showCreateEntityModal={props.showCreateEntityModal}
        setShowCreateEntityModal={props.setShowCreateEntityModal}
      />
    );
  }
};

export default ClientsList;
